import { render, staticRenderFns } from "./ListItemDetailHorizontal.vue?vue&type=template&id=f5d6f91a&"
import script from "./ListItemDetailHorizontal.vue?vue&type=script&lang=js&"
export * from "./ListItemDetailHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports